import gsap from "gsap";
import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SmoothImage from "./gsap/smoothImage";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
	(() => {
		const lenis = new Lenis();

		lenis.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 2000);
		});

		gsap.ticker.lagSmoothing(0);
		window.lenis = lenis;
	})();

	(() => {
		const rowTls = new Map();

		const rowsSelector = ".scroll-row";

		document.querySelectorAll(rowsSelector).forEach((row) => {
			const tl = gsap.timeline({
				duration: 1,
				scrollTrigger: {
					trigger: row,
					start: "top bottom",
					bottom: "bottom top",
					scrub: true,
				},
			});

			rowTls.set(row, tl);
		});

		const smoothImages = document.querySelectorAll("[data-smooth-image='true']");
		smoothImages.forEach((module) => {
			const fromY = module.dataset.smoothImageFromY;
			const parentToY = module.dataset.smoothImageParentToY;
			const scale = module.dataset.smoothImageScale;

			const image = module.querySelector("img");
			new SmoothImage(
				image,
				{
					fromY,
					parentToY,
					scale,
				},
				rowTls
			);
		});
	})();
});
